import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Heading } from 'Components/_theme'
import { LanguageDropdown } from 'Components/LanguageDropdown/LanguageDropdown'

import { setRouteTitle } from 'Portal/src/router/Router.utils'

export const PurchaseSuccessfulContent = () => {
  const intl = useIntl()

  useEffect(() => {
    setRouteTitle(
      intl.formatMessage({
        id: 'PurchaseSuccessfulContent_heading',
      }),
    )
  }, [intl])

  return (
    <>
      <Heading className="PurchaseContent-heading" size={1}>
        <FormattedMessage id="PurchaseSuccessfulContent_heading" />
      </Heading>

      <div className="PurchaseContent-content">
        <p>
          <FormattedMessage id="PurchaseSuccessfulContent_content_line1" />
        </p>

        <p>
          <FormattedMessage id="PurchaseSuccessfulContent_content_line2" />
        </p>

        <p>
          <FormattedMessage id="PurchaseSuccessfulContent_content_line3" />
        </p>
      </div>

      <LanguageDropdown isLandingPage />
    </>
  )
}
